import InputType from 'common/form/InputType';
import ButtonSelect from 'common/form/widgets/common/ButtonSelect';
import { Form, Input } from 'decorator-form';


const labelPosition = ButtonSelect.registerWithOptions([
	{value: 'tooltip', label: 'Tooltip'},
	{value: 'on', label: 'On Indicator'},
	{value: 'below', label: 'Below Indicator'}
]);

@Form({title: "Progress Bar View Config"})
export default class ProgressBarViewConfig {

	@Input({type: InputType.COLOR, title: "Background"})
	public backgroundColor: string;

	@Input({type: InputType.COLOR, title: "Bar Color"})
	public barBackgroundColor: string;

	@Input({type: InputType.UNIT, title: "Height"})
	public height: string = "12px";

	@Input({type: InputType.UNIT, title: "Border Radius"})
	public borderRadius: string;

	@Input({
		type: labelPosition,
		title: "Label Position",
		description: "try tooltip or below for longer labels"
	})
	public labelPosition: 'tooltip' | 'on' | 'below';

	@Input({type: InputType.COLOR, title: "Label Color"})
	public labelColor?: string;

	@Input({type: InputType.CHECKBOX, title: "Animate"})
	public animate?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Circle"})
	public circle?: boolean;

	@Input({type: InputType.NUMBER_POSITIVE, title: "Circle Size"})
	public circleSize?: number = 120;

	@Input({type: InputType.NUMBER, title: "Circle Stroke Width"})
	public strokeWidth?: number;

	@Input({type: InputType.MARGIN, title: "Margin"})
	public margin?: string = "0 0 0 0";
}



// WEBPACK FOOTER //
// ./src/common/views/progressBar/ProgressBarConfig.ts